export default {
  form: {
    amount: {
      label: 'Prezzo',
    },
    has_sales_based_discount: {
      label: 'Sconti basati sulle vendite mensili',
    },
  },
  labels: {
    month: 'mese',
    varies_by_tier: 'varia per fascia',
    max_price: '* Prezzo massimo: {{amount}}',
    sales_based_discount:
      'fino a +{{threshold}} vendite minime in un mese. Successivamente prezzo normale {{amount}} netto/mese',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (inclusa)',
    exclusive: 'al mese più {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Seleziona',
    save: 'Salva',
    use_default_price: 'Usa il prezzo predefinito',
  },
};
